import { __awaiter } from "tslib";
import mergeWith from 'lodash-es/mergeWith';
import { DEV_HUB_URL_STRING } from '../../../constants';
export function mergeResults(currentArgs, WebApi, extraOptions, rawBaseQuery, rawBaseQueryIntegration, hubUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        if (isFetchArgs(currentArgs) && currentArgs.url.includes('license-access') && hubUrl) {
            if (hubUrl.includes(DEV_HUB_URL_STRING)) {
                return rawBaseQuery(currentArgs, WebApi, extraOptions);
            }
            if (hubUrl.includes('integration')) {
                return rawBaseQueryIntegration(currentArgs, WebApi, extraOptions);
            }
        }
        const baseResult = yield rawBaseQuery(currentArgs, WebApi, extraOptions);
        const resultIntegration = yield rawBaseQueryIntegration(currentArgs, WebApi, extraOptions);
        const result = mergeWith(baseResult, resultIntegration, (obj, src) => Array.isArray(obj) ? obj.concat(src) : undefined);
        return result;
    });
}
export function isFetchArgs(args) {
    return typeof args === 'object';
}
//# sourceMappingURL=BentleyAccessTokenApiUtils.js.map